import moment from "moment";
import { notification } from "antd";
import { WDQMS_API, fetchData } from "../../utils/api";
import { variablesSlug } from "../../utils/general";
import * as actionTypes from "./actionTypes";
import {
  loadInitialPeriods,
  loadAllPeriods,
  setCalendarPeriods
} from "./action_utils";

export const setPeriodDataKey = data => {
  return {
    type: actionTypes.SET_PERIOD_DATA_KEY,
    payload: data
  };
};

export const setActiveLayerName = data => {
  return {
    type: actionTypes.SET_ACTIVELAYERNAME,
    payload: data
  };
};

export const setProperty = data => {
  return { type: actionTypes.SET_PROPERTY, payload: data };
};

export const setError404 = () => {
  return {
    type: actionTypes.SET_ERROR_404
  };
};

export const isEmpty = obj => {
  return Object.keys(obj).length === 0;
};
export const updatePeriodTypes = data => {
  return {
    type: actionTypes.UPDATE_PERIOD_TYPES,
    payload: data
  };
};

export const getVariableID = (fileType, variable) => {
  return variablesSlug[fileType][variable];
};

export const setLevel = data => {
  return {
    type: actionTypes.SET_LEVEL,
    payload: data
  };
};

let sixHourFetched = false;
let dailyFetched = false;

// call fetchDataFromApi only once per fileType
export const setSelectedStation = data => {
  return {
    type: actionTypes.SET_SELECTED_STATION,
    payload: data
  };
};

export const initializeMap = data => {
  return {
    type: actionTypes.INITIALIZE_MAP,
    payload: data
  };
};

export const fetchGCOSDataFromApi = payload => {
  return dispatch => {
    // If we have URL params, set them to the selected
    // params for the menu and map
    if (!isEmpty(payload.params)) {
      if (payload.params.variable) {
        let report;
        // For GUAN if there is 'payload.params.variable'
        // it means that the report is "quality"
        if (payload.fileType === "guan") {
          report = "quality";
        } else if (payload.fileType === "gsn") {
          // For GSN if there is 'payload.params.variable'
          // it means that the report is "completeness"
          report = "completeness";
        }
        dispatch(
          setProperty({
            type: payload.fileType,
            key: "selectedReport",
            value: report
          })
        );

        dispatch(
          setProperty({
            type: payload.fileType,
            key: "selectedVariable",
            value: payload.params.variable
          })
        );
      } else {
        // Otherwise, the report is "availability"
        dispatch(
          setProperty({
            type: payload.fileType,
            key: "selectedReport",
            value: "availability"
          })
        );
      }

      dispatch(
        setProperty({
          type: payload.fileType,
          key: "selectedDate",
          value: payload.params.date
        })
      );
    }

    if (!payload.alreadyFetched) {
      fetchData(`${WDQMS_API}/gcos/periods/?network=${payload.fileType}`)
        .then(response => {
          // response.data.length === 0 -> NO DATA
          if (response.data.length === 0) {
            dispatch(
              setProperty({
                type: payload.fileType,
                key: "noData",
                value: true
              })
            );
            // set the data (for a particular fileType) as fetched
            // so that won't be fetched a second time
            dispatch(
              setProperty({
                type: payload.fileType,
                key: "dataFetched",
                value: true
              })
            );
          } else {
            let tempObj = {};
            for (let p of response.data) {
              tempObj[moment.utc(p.date).format("YYYY-MM")] = {
                id: p.id
              };
            }

            dispatch(
              setProperty({
                type: payload.fileType,
                key: "dates",
                value: tempObj
              })
            );

            // the default date is the lastest one available
            const lastDate = Object.keys(tempObj)[0];

            if (!payload.params.date) {
              dispatch(
                setProperty({
                  type: payload.fileType,
                  key: "selectedDate",
                  value: lastDate
                })
              );
            }
            dispatch(
              setProperty({
                type: payload.fileType,
                key: "readyToFillMenu",
                value: true
              })
            );
            // set the data (for a particular fileType) as fetched
            // so that won't be fetched a second time
            dispatch(
              setProperty({
                type: payload.fileType,
                key: "dataFetched",
                value: true
              })
            );
          }
        })
        .catch(error => {
          // TO DO
        });
    } else {
      console.log(`${payload.fileType} data already fetched`);
    }
  };
};
